import { Box, Typography } from '@mui/material';
import type { FC } from 'react';
import { SEVERITY_TONES, type EdrSeverityLevel } from './edrTokens';

type EdrSeverityPillProps = {
  level: EdrSeverityLevel;
  label?: string;
};

export const EdrSeverityPill: FC<EdrSeverityPillProps> = ({ level, label }) => {
  const tone = SEVERITY_TONES[level] ?? SEVERITY_TONES.critical;
  const text = label ?? tone.label;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1,
        py: 0.25,
        borderRadius: '10px',
        bgcolor: tone.bg,
        fontSize: 11,
        fontWeight: 600,
        color: tone.color,
        textTransform: 'capitalize',
      }}
    >
      <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: tone.color }} />
      <Typography component="span" sx={{ fontSize: 11, fontWeight: 600, color: tone.color, lineHeight: '16px' }}>
        {text}
      </Typography>
    </Box>
  );
};
